const state = {
  cart: [
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
  ],
};

const getters = {
  getCart(state) {
    return state.cart;
  },
};

const mutations = {
  SET_CART(state, index, payload) {
    state.cart[index] = payload;
  },
};

const actions = {
  setCart({ commit }, index, payload) {
    commit("SET_CART", index, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
